<div class="container is-fluid">
  <div class="box">
    <div class="columns">
      <div class="column" *ngFor="let item of results">
        <div class="box">
          <h3 class="title is-3">{{ item.name }}</h3>

          <ng-container *ngIf="item.name === 'funds'">
            <div class="card" *ngFor="let hit of item.response.hits.hits">
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-48x48">
                      <span class="tag is-link">{{
                        hit._source.allShareClassTickerSymbol[0]
                      }}</span>
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4">{{ hit._source.fundKey }}</p>
                    <p class="subtitle is-6">{{ hit._source.assetClass }}</p>
                  </div>
                </div>

                <div class="content">
                  Additional shareclasses<br />
                  <a
                    href="#"
                    *ngFor="
                      let shareclass of hit._source.allShareClassTickerSymbol
                    "
                    ><span class="tag is-link is-light">{{
                      shareclass
                    }}</span></a
                  >
                </div>
              </div>
            </div>
          </ng-container>


          <ng-container *ngIf="item.name === 'literature'">
            <div class="card" *ngFor="let hit of item.response.hits.hits">
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-48x48">
                        <span class="tag is-danger">PDF</span>                      
                    </figure>
                  </div>
                  <div class="media-content">
                    <a class="is-2" href="{{ hit._source.reference }}">{{ hit._source.title }}</a>
                    <p class="subtitle is-6">{{ hit._source.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          
          

          <ng-container *ngIf="item.name === 'pages'">
            <div class="card" *ngFor="let hit of item.response.hits.hits">
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-40x40">
                        <img class="is-rounded" src="https://www.franklintempleton.com/content-us/images/graphics/en-us/en-us-retail/search-icons/generic.png">
                      </figure>
                  </div>
                  <div class="media-content">
                    <a class="is-2" href="{{ hit._source.reference }}">{{ hit._source.title }}</a>
                    <p class="subtitle is-6">{{ hit._source.description }}</p>
                  </div>
                </div>

              </div>
            </div>
          </ng-container>
          
          
        </div>
      </div>
    </div>
  </div>
</div>
